/**
 * Блог: кнопка «Скопировать ссылку» в блоке «Share».
 *
 * Кнопка — иконка (по макету), поэтому итог копирования показывается классом `is-copied`:
 * кнопка пружинит, по рамке расходится кольцо, над ней всплывает подсказка «Скопировано»
 * (всё на псевдоэлементах, разметку кнопки не трогаем). Через две секунды всё возвращается.
 */
const COPIED_DURATION_MS = 2000;

export function initBlog() {
  document.querySelectorAll('[data-blog-copy]').forEach((button) => {
    const initialTitle = button.getAttribute('title') || '';
    let resetTimer = null;

    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(button.dataset.blogCopy);
      } catch (e) {
        // Буфер обмена недоступен (http, старый браузер) — молча: адрес есть в строке браузера.
        return;
      }

      // Повторный клик во время показа — анимация проигрывается заново, а не обрывается таймером
      // первого клика.
      clearTimeout(resetTimer);
      button.classList.remove('is-copied');
      void button.offsetWidth;

      button.classList.add('is-copied');
      button.setAttribute('title', button.dataset.blogCopied || initialTitle);

      resetTimer = setTimeout(() => {
        button.classList.remove('is-copied');
        button.setAttribute('title', initialTitle);
      }, COPIED_DURATION_MS);
    });
  });
}
